export enum Token {
  AccessToken = 'accessToken',
  RefreshToken = 'refreshToken'
}

export const enum LocalStorageItem {
  IsLogged = 'isLogged'
}
